<div class="subtitle" *ngIf="tableData?.dataSet.length">
    {{ subtitleWidget }}
</div>
<div *ngIf="requestState">
    <app-table
        *ngIf="tableData?.dataSet.length"
        [tableView]="tableData"
    ></app-table>
</div>
